import { render, staticRenderFns } from "./video-box-single.vue?vue&type=template&id=40292ca1&scoped=true&"
import script from "./video-box-single.vue?vue&type=script&setup=true&lang=ts&"
export * from "./video-box-single.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./video-box-single.vue?vue&type=style&index=0&id=40292ca1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40292ca1",
  null
  
)

/* custom blocks */
import block0 from "./video-box-single.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports